import {
    DIC
} from '@/const/dic'
import {
    validateCapitalUnderline,
    validateChinese
} from '@/util/validate'


export const checkDetailOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
        label: "开始时间",
        prop: "startTime",
        type: "datetime",
        sortable: true,
        format: "yyyy-MM-dd HH:mm:ss",
        addVisdiplay: false,
        editVisdiplay: false
    },{
        label: "结束时间",
        prop: "endTime",
        type: "datetime",
        sortable: true,
        format: "yyyy-MM-dd HH:mm:ss",
        addVisdiplay: false,
        editVisdiplay: false
    },

        {
            label: "退回原因",
            prop: "returnReason",
            type: "input"
        },
        {
            label: "本期进货总金额",
            prop: "currentTotalBalance",
            type: "input"
        },
        {
            label: "账户总余额",
            prop: "totalBalance",
            type: "input"
        },
        {
            label: "审核时间",
            prop: "confirmTime",
            type: "datetime",
            sortable: true,
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true
        }

    ]
};